import React, {useContext, useState, useEffect} from "react";
import NumericInput from 'react-numeric-input';
import QuoteContext from "../../../quote-context";

const EditActivity = ({event, hide, height}) => {

	const {formData, formDispatcher} = useContext(QuoteContext);
	const[dayOptions, setDayOptions] = useState([]);

	const[data, setData] = useState({
		day: event.day,
		pax: event.pax,
		preferredTimeSlot: event.preferredTimeSlot
	})

	const handleSubmit = (e) => {
		e.preventDefault();
		formDispatcher({type: "EDIT_ACTIVITY", id: event.id, pax: data.pax, preferredTimeSlot: data.preferredTimeSlot, day: data.day })
		hide();
	}

	useEffect(() => {
		if(formData.days < 2 ){
			setDayOptions([]);
		} else {
			let days = [];
			for(let i=1; i <= formData.days; i++){
				days.push({label: `Day ${i}`, value: i});
			}
			setDayOptions(days);
		}
	},[formData])

	return (
		<div className="modal-content" style={{minHeight: height }}>
			<div className="pd">
				<div className="bg-light-blue pd radius">
					<div className="full-width-block">
						<div className="row no-padding">
							<div className="column">
								<div className="align-content vertical center mg-b">
									<span className="icon icon-edit medium black left"></span>
									<h4 className="no-mg-b">Editing {event.name}</h4>
								</div>
							</div>
						</div>
					</div>

					{dayOptions.length > 0 ? (
						<>
							<div className="full-width-block mg-b-sm">
								<div className="row no-padding align-content horizontal left">
									<div className="column one-fifth mg-b-tch-sm">
										<span>Move to:</span>
									</div>

									<div className="column one-third">
										<select 
											name="move-day" 
											className="form-select white radius full-width small mg-b-sm" 
											value={data.day} 
											onChange={e => setData({...data, day: e.target.value})}
										>
											{dayOptions.map( (item) => <option key={`day-option-${item.value}`} value={item.value}>{item.label}</option> )}
										</select>
									</div>
								</div>
							</div>
						</>
					): (
						<button 
							onClick={() => {
								formDispatcher({type:"ADD_DAY"})
								setData({...data, day: data.day + 1})
							}} 
							className="button plain mg-b-sm"
						>
							<div className="text-small nowrap italic">Need to <span className="text-small underline">move to another day?</span></div>
						</button>
					)}

					<div className="full-width-block mg-b">
						<div className="row no-padding align-content horizontal left">
							<div className="column one-fifth mg-b-tch-sm">
								<span>Time slot:</span>
							</div>

							<div className="column one-third">
								<select value={data.preferredTimeSlot == 0 ? 0 : 1} onChange={e => setData({...data, preferredTimeSlot: e.target.value})} name="time-dropdown" className="form-select white radius full-width small">
									{event.period == 0 ?(
										<>
											<option value={0}>Morning</option>
											<option value={1}>Afternoon</option>
										</>
									): <option value={2}>Evening</option>}

								</select>
							</div>
						</div>
					</div>

					<div className="full-width-block mg-b">
						<div className="row no-padding align-content horizontal left">
							<div className="column one-fifth mg-b-tch-sm">
								<span>Guests:</span>
							</div>
							<div className="column one-third">
								<NumericInput min={3} max={50} value={data.pax} mobile={true} onChange={value => setData({...data, pax: value})}/>
							</div>
						</div>
					</div>

					<div className="full-width-block">
						<div className="row no-padding align-content horizontal left">
							<div className="column">
								<div className="align-content vertical center wrap-mobile">
									<button className="button secondary transparent fit-content center fill-mob radius small mg-r-tab mg-b-mob" onClick={hide}>Cancel edit</button>
									<button className="button secondary fit-content fill-mob center radius small" onClick={handleSubmit}>Confirm changes</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)

}

export default EditActivity;
